import { Slide, Snackbar } from '@mui/material';
import { Fragment, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { metaSliceSelectors } from 'redux/slices/metaSlice.hooks';
import { Alert } from '@act/storybook';

import './toast.scss';

const ToastPortal = () => {
  const [domReady, setDomReady] = useState(false);
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const toast = metaSliceSelectors.useSelectToastConfig();

  function handleClose() {
    setIsOpen(false);
  }

  useEffect(() => {
    setDomReady(true);
  }, []);

  useEffect(() => {
    if (toast.message && toast.severity) {
      setIsOpen(true);
    }
  }, [toast]);

  // Convert string message with \n to React element with <br /> tags
  const renderMessage = (message: string | null) => {
    if (!message) return '';

    if (message.includes('\n')) {
      return (
        <>
          {message.split('\n').map((line, index, array) => (
            <Fragment key={index}>
              {line}
              {index < array.length - 1 && <br />}
            </Fragment>
          ))}
        </>
      );
    }

    return message;
  };

  return domReady
    ? createPortal(
        <Snackbar
          open={isOpen}
          onClose={handleClose}
          autoHideDuration={3000}
          anchorOrigin={{
            horizontal: 'center',
            vertical: 'bottom',
          }}
          TransitionComponent={Slide}
          sx={{ zIndex: 9999 }}
        >
          <div className="snackbar__alert-container">
            <Alert
              variant="filled"
              severity={toast?.severity || 'info'}
              closable
              onClose={handleClose}
              trackingName="toast-notification-alert"
              {...(toast?.details && {
                action: {
                  label: 'Copy details',
                  onClick: () => {
                    void navigator.clipboard.writeText(
                      JSON.stringify(toast.details, undefined, 2)
                    );
                  },
                },
              })}
            >
              {renderMessage(toast?.message || null)}
            </Alert>
          </div>
        </Snackbar>,
        document.getElementById('toast-portal')
      )
    : null;
};

export default ToastPortal;
